import { render, staticRenderFns } from "./OriginList.vue?vue&type=template&id=773b1580"
import script from "./OriginList.vue?vue&type=script&lang=js"
export * from "./OriginList.vue?vue&type=script&lang=js"
import style0 from "./OriginList.vue?vue&type=style&index=0&id=773b1580&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports